import { render, staticRenderFns } from "./smallProgramManageHandle.vue?vue&type=template&id=40fb2337&scoped=true&"
import script from "./smallProgramManageHandle.vue?vue&type=script&lang=ts&"
export * from "./smallProgramManageHandle.vue?vue&type=script&lang=ts&"
import style0 from "./smallProgramManageHandle.vue?vue&type=style&index=0&id=40fb2337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb2337",
  null
  
)

export default component.exports